export default class BitrateMonitor {
  constructor() {
    this.reset();
  }

  getAll() {
    return {
      current: this.getCurrent(),
      min: this.getMin(),
      max: this.getMax(),
    };
  }

  getCurrent() {
    return this.bitrate.current;
  }

  getMax() {
    return this.bitrate.max;
  }

  getMin() {
    return this.bitrate.min;
  }

  reset() {
    this.bitrate = {
      current: 0,
      max: 0,
      min: 0,
    };
  }

  updateBitrates(bitrate) {
    this.bitrate.current = bitrate;

    if (bitrate > this.bitrate.max) {
      this.bitrate.max = bitrate;
    }

    if (bitrate < this.bitrate.min) {
      this.bitrate.min = bitrate;
    }
  }
}
